module.exports = __webpack_public_path__ + "media/images/gallery/constellations/pegasus/peg_names-fd8bd4c145fe374f1f9edf0a27ecf5dd.gif";